<!-- WidgetItem is provided by the BaseWidget component from GridStack, and we don't have direct control over it. We only need to verify that it is defined. -->
@if (widgetItem && widgetItem.id) {
  @let loading = !!loadingSg();
  @let rendering = renderingSg();
  <div class="atn-mosaic-dev-widget-frame">
    <atn-mosaic-widget
      class="atn-mosaic-dev-widget-frame__content"
      [refId]="widgetItem.id"
      [loading]="loading"
      [rendering]="rendering"
    />

    <div class="atn-mosaic-dev-widget-frame__actions">
      <atn-ds-button
        [isIcon]="true"
        type="white"
        (click)="editButtonClickHandler()"
      >
        <i class="atn-icon atn-edit atn-blue"></i>
      </atn-ds-button>
      <atn-ds-button
        [isIcon]="true"
        type="white"
        (click)="removeButtonClickHandler()"
      >
        <i class="atn-icon atn-trash atn-red"></i>
      </atn-ds-button>
    </div>
  </div>
}
